const CustomSelect = ({
  children,
  data,
  placeholder,
  optionLabel,
  optionValue,
  ...restProps
}) => {
  return (
    <select {...restProps}>
      <option disabled value={null}>
        {placeholder}
      </option>
      {data?.length &&
        data.map((item) => {
          const value = optionValue ? item[optionValue] : item;
          return (
            <option key={value} value={value}>
              {optionLabel ? item[optionLabel] : item}
            </option>
          );
        })}
    </select>
  );
};

export default CustomSelect;
